import { StreamHandler } from "./stream.handler";
import type { PlayerTournamentProgressSchema } from "@/types";
import { SubscribeTournamentProgress, UpdateTournamentProgress } from "@/types";
import { useAppStore } from "@/stores";
import { recomputeChases } from "@/stores/derive";

export class TournamentProgressHandler extends StreamHandler<
  PlayerTournamentProgressSchema[]
> {
  protected readonly subscribeType = SubscribeTournamentProgress;
  protected readonly updateType = UpdateTournamentProgress;

  protected isBusy(): boolean {
    const s = useAppStore.getState().tournamentProgress;
    return s.subscribed || s.loading;
  }
  protected setLoading(loading: boolean): void {
    useAppStore.getState().setTournamentProgressLoading(loading);
  }
  protected setSubscribed(subscribed: boolean): void {
    useAppStore.getState().setTournamentProgressSubscribed(subscribed);
  }
  protected clear(): void {
    useAppStore.getState().clearTournamentProgress();
    recomputeChases();
  }
  protected apply(data: PlayerTournamentProgressSchema[]): void {
    useAppStore.getState().setTournamentProgressItems(data);
    // A chase folds this per-player row into its view (spins, targets, won rungs); the
    // leaderboard tournaments read the raw slice directly and need no re-derive here.
    recomputeChases();
  }
}

export const tournamentProgressHandler = new TournamentProgressHandler();
